const ar = {
  general: {
    position: 'المنصب',
    updateSuccess: 'تم التحديث بنجاح!',
    editProfileImg: 'تحرير صورة ملف التعريف',
    editCoverImg: 'تحرير صورة الغلاف',
    register: 'تسجيل الاشتراك',
    login: 'تسجيل الدخول',
    date: 'التاريخ',
    export: 'تصدير',
    or: 'أو',
    end: 'إنهاء',
    confirmEmail: 'تأكيد عنوان البريد الإلكتروني',
    password: 'كلمة المرور',
    forgetPassword: 'هل نسيت كلمة المرور؟',
    changePassword: 'تغيير كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    knownAs: 'معروف باسم',
    oldPassword: 'كلمة المرور القديمة',
    newPassword: 'كلمة المرور الجديدة',
    minLength: 'الحد الأدنى للطول هو {n}',
    unmatched: '{col} غير متطابق.',
    chooseAnotherAccount: 'تسجيل الدخول بحساب آخر',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    required: 'حقل مطلوب.',
    country: 'البلد',
    new: 'جديد',
    username: 'اسم المستخدم',
    category: 'الفئة'
  },
  livetour: 'صالة العرض',
  country: {
    JP: 'اليابان',
    KR: 'كوريا',
    HK: 'هونغ كونغ وماكاو',
    SG: 'سنغافورة',
    MY: 'ماليزيا',
    TH: 'تايلاند',
    VN: 'فيتنام',
    ID: 'إندونيسيا',
    PH: 'الفلبين',
    EU: 'أوروبا',
    NA: 'أمريكا الشمالية',
    NZ: 'نيوزيلندا وأستراليا',
    TW: 'تايوان'
  },
  vrlounge: {
    ticketNotOnboardHint: 'يُرجى الدخول إلى المعرض الافتراضي عبر الإنترنت بعد تجهيز التذكرة في المعرض المادي.',
    cannotChangeAfterSubmit: 'لا يمكن التغيير بعد الإرسال',
    hintLogin: 'إذا قمت بالتسجيل باستخدام رقم تذكرتك، فالرجاء النقر فوق Log In "تسجيل الدخول" لتسجيل الدخول عن طريق البريد الإلكتروني الخاص بك.',
    lounge: 'غرفة الواقع الافتراضي',
    networking: 'الشبكات',
    profile: 'ملف التعريف الخاص بي',
    peopleOnline: 'الأشخاص على الإنترنت',
    totalVisitors: 'إجمالي عدد الزوار',
    connect: 'اتصال',
    waitConfirmed: 'انتظر حتى يتم التأكيد',
    isConfirmed: 'تم تأكيد',
    confirm: 'تؤكد',
    reject: 'يرفض',
    confirmReject: 'هل أنت متأكد من رغبتك في الرفض',
    hintReject: 'لا يمكن الإلغاء',
    thinkTwice: 'اسمحوا لي أن أفكر مرتين',
    rejectInvitation: 'رفض الدعوة',
    connectSuccess: 'تم الاتصال بنجاح!',
    block: 'تصميم',
    visitor: 'زائر',
    exhibitor: 'عارض',
    invitationTitle: 'رسالة دعوة شخصية',
    invitationPlaceholder: 'مرحبًا ، أتمنى التواصل معك! (1000 حرف على الأكثر)',
    noTicketRecord: 'لا يوجد سجل تذاكر. يُرجى شراء تذكرة.',
    invalidTicket: 'تذكرة غير صالحة',
    enterTicket: 'يُرجى إدخال رقم التذكرة الخاصة بك',
    sent: 'المرسلة',
    received: 'المستلمة',
    connected: 'المتصلة',
    agreeToContinue: 'يجب أن توافق على الشروط والأحكام وسياسة الخصوصية للمتابعة.',
    ticketUsed: 'تم استخدام هذه التذكرة.',
    passwordRule: 'يجب أن تحتوي كلمة المرور على 8 أحرف، حرف واحد ورقم واحد على الأقل.',
    cardExchange: 'يرغب الزائر في تبادل بطاقات العمل معك، يُرجى تأكيد قبول التبادل أو رفضه.',
    loginToAccount: 'تسجيل الدخول إلى حسابك',
    keepLogin: 'أبقني مسجلًا',
    cantLogin: 'هل لا يمكنك تسجيل الدخول؟ اضغط هنا',
    here: 'هنا',
    allRole: 'كل الأدوار',
    sortNameAtoZ: 'الاسم (أ ← ي)',
    sortNameZtoA: 'الاسم (ي ← أ)',
    onlineNewToOld: 'آخر وقت لتسجيل الدخول (الأحدث)',
    onlineOldToNew: 'آخر وقت لتسجيل الدخول (أقرب)',
    exhibitorFirst: 'العارض أولا',
    visitorFirst: 'الزائر أولا',
    inviteTimeNewToOld: 'وقت الدعوة (الأحدث)',
    inviteTimeOldToNew: 'وقت الدعوة (الأقدم)',
    basicInfo: 'معلومات أساسية',
    contact: 'اتصل',
    contactInfo: 'معلومات الاتصال',
    state: 'حالة',
    sentRequest: 'ارسل طلب',
    haveNotConfirmed: 'لم تؤكد بعد',
    message: 'رسالة',
    sendMessageTo: 'إرسال رسالة إلى'
  },
  sort: 'نوع',
  filter: 'منقي',
  test: 'اختبار',
  apply: 'تطبيق',
  all: 'الكل',
  livingroom: 'غرفة المعيشة',
  diningroom: 'غرفة تناول الطعام',
  kitchen: 'المطبخ',
  bedroom: 'غرفة النوم',
  study: 'غرفة المذاكرة',
  bathroom: 'الحمام',
  toilet: 'المرحاض',
  garden: 'الحديقة',
  garage: 'المرأب',
  outdoors: 'الفسحات الخارجية',
  others: 'غير ذلك',
  vrTooltip: 'وضع الواقع الافتراضي متاح فقط للأجهزة المحمولة',
  vrInstructions: 'يُرجى وضع <strong> الهاتف </strong> في <strong> سماعة رأس الواقع الافتراضي</strong>.',
  send: 'إرسال',
  scanQrCode: 'امسح رمز الاستجابة السريعة ضوئيًا لعرض الجولة الافتراضية على هاتفك.',
  logOut: 'تسجيل الخروج',
  postAsAnonymous: 'لا شكرًا، سأقوم بالنشر كمجهول.',
  loginGoogle: 'تسجيل الدخول باستخدام Google+',
  loginFacebook: 'تسجيل الدخول باستخدام Facebook',
  postComment: 'اترك تعليقًا',
  selectAction: 'اختر من فضلك',
  noBuilding: 'عذرًا، هذه LiveTour غير موجودة',
  browserNoSupport: '<h3>عذرًا، متصفحك غير مدعوم. </h3><p> يُرجى تنزيل وتثبيت متصفح آخر مثل <a href="https://www.google.com/chrome/browser/desktop"> Chrome </a>,<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">I IE11 </a> أو <a href="https://www.mozilla.org/en-US/firefox/new/"> Firefox </a>.</p>',
  webGlNoSupport: '<h3> فشل في الحصول على سياق WebGL. قد لا يدعم المستعرض أو الجهاز الذي تستخدمه WebGL. </h3>',
  urlNoSupportIFrameError: 'انتهت صلاحية هذا الارتباط أو أن الصفحة لا تقبل ارتباطات خارجية مضمنة.',
  noPanoramas: 'عفوًا！البانوراما غير موجودة.',
  buildingNotFound: '<h3>عفوًا! الارتباط غير موجود. </h3><p> لا يمكن العثور علىLiveTour. </p><a href="https://www.twmsolution.com/"> شاهد LiveTours الأخرى </a>',
  buildingNotInPropertyRedirect: '<h3>عفوًا! تمت إزالة LiveTour. </h3><p> يتم إعادة توجيهك إلى LiveTour الأول من القائمة ...... </p>..',
  information: 'المعلومات',
  panoSelect: 'الصور البانورامية',
  floorplan: 'مخطط الطابق',
  qrCode: 'رمز الاستجابة السريعة',
  music: 'الموسيقى',
  openMusic: 'قم بتشغيل الموسيقى الخلفية',
  closeMusic: 'قم بإيقاف تشغيل الموسيقى الخلفية',
  gyro: 'جيروسكوب',
  vrmode: 'وضع الواقع الافتراضي',
  fullscreen: 'وضع ملء الشاشة',
  like: 'إعجاب',
  comment: 'تعليق',
  propertyInfo: 'معلومات المجموعة',
  buildingInfo: 'معلومات LiveTour',
  buyNow: 'اشترِ الآن',
  viewAtHome: 'عرض في الواقع المعزز',
  learnMore: 'اعرف المزيد',
  contactSupplier: 'اتصل بالمورد',
  memo: 'مذكرة',
  location: 'الموقع',
  promotionText: 'الجولات الافتراضية أصبحت سهلة >',
  promotionLinkText: 'ابدأ بـ 5 دولارات',
  close: 'إغلاق',
  addComment: 'إضافة تعليق',
  share: 'مشاركة',
  leaveInfoContinue: 'يُرجى إدخال المعلومات الخاصة بك لعرض LiveTour',
  company: 'الشركة',
  companyName: 'اسم الشركة',
  name: 'الاسم',
  firstName: 'الإسم الأول',
  lastName: 'الاسم الأخير',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  occupation: 'المهنة',
  emailFormatInvalid: 'تنسيق بريد إلكتروني غير صالح.',
  duplicateEmail: 'البريد الإلكتروني مكررة',
  privacyPolicy: 'سياسة الخصوصية',
  userTerms: 'الشروط والأحكام',
  visitorLogin: 'هل لديك حساب؟',
  visitorAgreement1: 'خصوصيتك تهمنا. بإرسال المعلومات الخاصة بك، فإنك توافق على {company} {privacyTag} و{termsTag}.',
  visitorAgreement2: 'أنت تفوض {company} بطلب أو إرسال بريد إلكتروني أو إرسال رسالة نصية أو بريد إلكتروني بمعلوماتك حول منتجات وخدمات {company}. يمكنك سحب هذا التخويل عن طريق الاتصال بنا على {email}.',
  visitorAgreement: 'أوافق على <a href="https://www.istaging.com/legal/terms_of_service" target="_blank"> شروط الاستخدام </a> و<a href="https://www.istaging.com/legal/privacy_policy" target="_blank"> سياسة الخصوصية </a>.',
  visitorLeaveDataReason: 'مرحبًا بك في هذه التجربة الافتراضية! ستتلقى رابط التحقق عبر البريد الإلكتروني، حتى تتمكن من الدخول، بمجرد إرسال معلومات الاتصال الخاصة بك.',
  visitorAgreePolicy: 'أوافق على أنه يجوز لمالك هذه التجربة الافتراضية الاتصال بي عبر البريد الإلكتروني أو الهاتف.',
  visitorEnterAccessKey: 'يُرجى إدخال رمز الوصول الذي تلقيته عبر البريد الإلكتروني. إذا لم تكن قد تلقيته، فتحقق من مجلد البريد العشوائي الخاص بك.',
  accessCode: 'رمز الوصول',
  accessCodeError: 'خطأ في رمز الوصول',
  receiveEmailVerification: 'يُرجى الحصول على رمز الوصول الخاص بك في البريد الإلكتروني.',
  verify: 'تحقق',
  back: 'رجوع',
  welcomeToLiveTour: 'مرحبًا بك في <strong>LiveTour</strong>',
  resend: 'إعادة إرسال',
  invalidAccessCode: 'رمز الوصول غير صالح',
  resendCodeError: 'فشل في إعادة إرسال رمز الوصول',
  website: 'الموقع الإلكترونى',
  cardMore: 'المزيد',
  clickNavigate: 'التنقل',
  showMore: 'عرض المزيد',
  searchTag: 'علامة البحث',
  somethingWrong: '<h3> عفوًا....حدث خطأ.... </h3><a href="https://www.istaging.com/en/contact"> أبلغ عن هذه المشكلة غير المعروفة </a>',
  GuidedTour: 'جولة إرشادية',
  ClientWelcome: 'مرحبًا',
  ClientFormHint: 'بالنقر على Call now "الاتصال الآن"، فأنا أوافق على <a href="https://www.istaging.com/legal/terms_of_service" target="_blank" class="link-yellow"> شروط الخدمة و</a> <a class="link-yellow" href="https://www.istaging.com/legal/privacy_policy" target="_blank"> سياسة الخصوصية </a> ويمكن للوكيل الاتصال بي عبر الهاتف',
  ClientFormWelcomeText: 'املأ المعلومات التالية وانقر على Call now "اتصل الآن". .<br> سيتم توجيهك عبر الإنترنت بواسطة وكيل.<br> قم بتوصيل سماعة الرأس والميكروفون وتأكد من أن لديك اتصال شبكة جيد للحصول على تجربة أفضل.',
  ClientWelcomeNamePhoneHint: 'الرجاء إدخال الاسم ورقم الهاتف',
  ClientWelcomeNameHint: 'يُرجى إدخال اسمك',
  ClientWelcomePhoneHint: 'الرجاء إدخال رقم الهاتف أو التنسيق غير صحيح',
  ClientWelcomeLanguage: 'اللغة',
  ClientWelcomeLanguageDesc: 'يُرجى تحديد لغة مرشد الجولة.',
  ClientWelcomeLanguageHint: 'الرجاء تحديد لغة',
  FieldRequired: '*مطلوب',
  ClientFormCallNow: 'الاتصال الآن',
  None: 'لا ينطبق',
  Agent: 'الوكيل',
  RememberMe: 'تذكر بياناتي',
  TheFieldIsRequired: '*حقل مطلوب',
  IncorrectFormat: 'خطأ في التنسيق',
  YouMustAgreeLicense: 'تحتاج إلى الموافقة على الشروط المذكورة أعلاه.',
  Submit: 'تقديم',
  BuildingNonPublicInfo: 'تم إخفاء LiveTour عن العرض',
  WebRTCNotSupportTitle: 'متصفحك لا يدعم ذلك',
  WebRTCNotSupportDesc: 'انسخ عنوان URL للصفحة والصقه في Google Chrome أو Firefox أو Safari',
  WebRTCNotSupportDesciOS: 'انسخ عنوان URL للصفحة والصقه في Safari',
  WebRTCNotSupportDescAndroid: 'انسخ عنوان URL للصفحة والصقه في Chrome أو Firefox',
  WebRTCNotSupportCopyButton: 'النسخ بنقرة واحدة',
  Copied: 'اكتمل النسخ',
  search: 'بحث',
  searchContent: 'محتوى البحث',
  noResult: 'لا يوجد نتائج',
  searchResult: 'نتيجة البحث',
  relatedResult: 'النتيجة ذات الصلة',
  scaleUp: 'تكبير الحجم',
  scaleDown: 'تصغير الحجم',
  viewIn3D: 'عرض ثلاثي الأبعاد',
  unableJoinMeeting: 'تعذر الانضمام إلى الاجتماع',
  invalidMeetingId: 'معرّف الاجتماع غير صالح',
  unableAccessMediaDevice: 'متصفحك يمنع الوصول إلى الكاميرا/ الميكروفون، يُرجى التحقق من إعدادات أذونات وسائط المتصفح.',
  connectingMeeting: 'ستستضيف اجتماع',
  meetingNotStartedYet: 'تعذر الانضمام إلى الاجتماع. لم يبدأ بعد.',
  joinedMeeting: 'أنت في الاجتماع',
  joiningMeeting: 'ستنضم إلى اجتماع',
  repeatJoinWarning: 'إذا انضممت مرة أخرى، فسيتم فصل الصفحة الأصلية المتصلة.',
  meetingIsOver: 'انتهى الاجتماع.',
  startAnotherMeeting: 'يُرجى الذهاب إلى المحرر لبدء اجتماع آخر.',
  closeMeeting: 'إغلاق',
  joinMeeting: 'الانضمام إلى الاجتماع',
  leaveMeeting: 'المغادرة',
  remainTime: 'الوقت المتبقي',
  meetingIsFull: 'الاجتماع الخاص بك مكتمل',
  connectionFail: 'فشل الاتصال',
  unableConnectMeeting: 'تعذر الانضمام إلى الاجتماع',
  joinMeetingFail: 'فشل الانضمام إلى الاجتماع',
  aboutEndMeeting: 'أنت على وشك إنهاء هذا الاجتماع',
  aboutLeaveMeeting: 'أنت على وشك مغادرة هذا الاجتماع',
  endedMeeting: 'انتهى الاجتماع',
  meetingRedirect: 'نقوم بتوجيهك إلى LiveTour.',
  leftMeeting: 'لقد غادرت هذا الاجتماع',
  waitMeeting: 'المضيف غادر مؤقتا. سيستمر الاجتماع بعد اتصال المضيف. إذا لم يتصل المضيف في غضون 5 دقائق، فسينتهي الاجتماع',
  copyLink: 'نسخ الرابط',
  copySuccess: 'تم النسخ بنجاح',
  confirm: 'موافق',
  cancel: 'إلغاء',
  IMServe: 'خدمة عملاء فورية',
  product: 'المنتج',
  pilot: 'إصدار تجريبي',
  pilotBooking: 'حجز جولة',
  pilotStop: 'وقف الإصدار التجريبي',
  pilotTours: 'الجولات',
  pilotPopularTours: 'الجولات المعروفة',
  pilotInfluencerList: 'قائمة مرشدي الجولات',
  pilotTourBy: 'جولة من خلال {influencer}',
  PilotDescription: 'الوصف',
  PilotDetailedInformation: 'المعلومات المفصلة',
  pilotSwitchTourNotice: 'أنت تقوم بتشغيل "{pilot1}" الآن.<br> هل تريد بالتأكيد بدء تشغيل "{pilot2}"؟',
  pilotSameTourNotice: 'أنت تقوم بتشغيل "{pilot1}" الآن.<br> هل تريد أن تبدأ من البداية؟',
  pilotPlayerPopupButtonYes: 'نعم',
  pilotRecorderStart: 'اضغط هنا للبدأ',
  pilotRecorderStop: 'اضغط هنا للتوقف',
  pilotRecorderUploading: 'جارٍ التحميل...',
  pilotRecorderUploadFailed: 'فشل التحميل',
  pilotRecorderPopupTitleNotice: 'الإشعار',
  pilotRecorderPopupTitleComplete: 'اكتمل التسجيل',
  pilotRecorderPopupTitleError: 'خطأ',
  pilotRecorderPopupTextNotice: '• وقت التسجيل محدد بـ 10 دقائق.<br>• يُرجى السماح للنظام بالوصول إلى الميكروفون.',
  pilotRecorderPopupTextComplete: 'اكتمل الفصل الخاص بك. <br> الرجاء المراجعة في محرر الواقع الافتراضي.',
  pilotRecorderPopupTextRelogin: 'يلزم إعادة تسجيل الدخول.',
  pilotRecorderPopupTextError: 'يُرجى التحقق من إذن الميكروفون في متصفحك.',
  pilotRecorderPopupButtonOK: 'موافق',
  pilotRecorderRemainTimeWarning: 'سينتهي وقت التسجيل البالغ 10 دقائق قريبًا. يُرجى إكمال التسجيل الخاص بك.',
  pilotTooltipTitle: 'تذكير ، يمكنك النقر هنا لرؤية المزيد من المسارات الإرشادية.',
  pilotTooltipConfirm: 'أرى! لنبدأ',
  pilotTooltipCancel: 'تخطي الجولة',
  selectPilot: 'تحديد الطيار',
  pilotInfluencer: 'مؤثر طيار',
  pilotChaptersTitle: 'فصول المسار (اختر الاستماع)',
  pilotReadMoreBtnLabel: 'عرض المحتوى الكامل',
  pilotSelfBrowsingModeMessageTitle: 'أدخل وضع التصفح الذاتي',
  pilotSelfBrowsingModeMessageContent: 'يمكنك العودة إلى وضع الجولة في أي وقت بالنقر فوق زر التشغيل.',
  pilotReplay: 'إعادة',
  pilotPrevious: 'السابق',
  pilotNext: 'التالي',
  pilotPause: 'وقفة',
  pilotPlay: 'تشغيل',
  pilotTurnOnSelfBrowsingMode: 'بدوره من وضع الجولة',
  pilotTurnOffSelfBrowsingMode: 'قم بتشغيل وضع الجولة',
  booking: {
    calendar: 'التقويم',
    reserve: 'حجز',
    dateSelectTitle: 'اختر الوقت الذي يناسبك.',
    backToSelect: 'اختر وقتًا مختلفًا',
    requiredField: 'هذا الحقل مطلوب',
    timeRange: 'النطاق الزمني',
    fieldMessage: 'الرسالة',
    confirm: 'تأكيد الحجز',
    pleaseWait: 'يُرجى الانتظار...',
    submitError: 'حدث خطأ أثناء إرسال الطلب:',
    reserveSuccess: 'تم الحجز بنجاح',
    thanksUser: 'لكم جزيل الشكر،',
    confirmingEmail: 'ستتلقى إشعارًا يؤكد تفاصيل الاجتماع قريبًا.',
    emailEmptyHint: 'البريد الإلكتروني فارغ.'
  },
  favorites: {
    title: 'المفضلة',
    add: 'إضافة إلى المفضلة',
    remove: 'حذف من المفضلة',
    category: {
      marker: 'المنتج',
      panorama: 'صالة العرض',
      company: 'الشركة',
      card: 'بطاقة العمل'
    },
    table: {
      image: {
        company: 'الشعار',
        marker: 'صورة المنتج',
        card: 'الصورة الرمزية'
      },
      name: {
        company: 'اسم الشركة',
        marker: 'اسم المنتج',
        card: 'الاسم'
      },
      description: { company: 'وصف الشركة', marker: 'وصف المنتج' },
      type: 'النوع',
      note: 'ملاحظة',
      company: 'الشركة',
      occupation: 'المهنة',
      listEmpty: 'لا شيء حتى الآن'
    },
    note: {
      empty: 'أدخل ملاحظة ... (حتى {n} حرفًا)',
      saved: 'تم الحفظ!'
    },
    pdf: {
      export: 'تصدير كملف PDF',
      exporting: 'جارٍ التصدير...',
      note: 'ملاحظة:',
      pager: 'صفحة {page} من {total}'
    }
  },
  introAssets: { enter: 'إدخال' },
  whiteList: {
    warnTitle: 'فشل المصادقة',
    warnContent: 'اسم المستخدم الخاص بك غير موجود في القائمة المصرح بها، يُرجى المحاولة مرة أخرى أو الاتصال بالمسؤول.'
  },
  instantMessaging: {
    quickQA: 'سؤال وجواب سريع',
    mediaMessage: 'تمت مشاركة ملف',
    locationMessage: 'تمت مشاركة ملف',
    startConversation: 'ابدأ محادثة مع المنظم في منطقة المعرض هذه!'
  },
  noSearchResult: 'لم يتم العثور على بيانات، يُرجى تغيير شروط الاستعلام والبحث مرة أخرى',
  tourring: {
    host: 'مضيف',
    noAnswer: 'جهة الاتصال الخاصة بك حاليًا غير قادر على الرد.',
    noPushId: 'جهة الاتصال الخاصة بك غير متوفرة حاليًا.',
    busy: 'جهة الاتصال الخاصة بك مشغولة بجولة إرشادية.',
    response: 'يُرجى الرجوع إلى تقويم الحجز.',
    goToReserve: 'الوصول إلى التقويم',
    dialing: 'جارٍ الطلب',
    dialingHint: 'بعد الاتصال، سيتم فتح علامة تبويب جديدة',
    handupPhoneHint: 'مكالمتك ليست متصلة بعد،',
    handupPhoneHint2: 'يُرجى تأكيد ما إذا كنت تريد قطع الاتصال أم لا.'
  },
  visitorCheckTheEmail: 'لقد أوشكت على الانتهاء من!<br> دعنا نؤكد عنوان البريد الإلكتروني الخاص بك. انتقل إلى صندوق الوارد الخاص بك وتحقق من البريد الإلكتروني الخاص بك بالنقر فوق الرابط الذي تلقيته.<br> أنت على بعد خطوة واحدة من الوصول إلى التجربة الافتراضية!',
  video360: { notAvailable: 'الفيديو غير متوفر في بلدك.' },
  utils: { more: 'عرض المزيد', less: 'عرض أقل' },
  productUnavailable: 'هذا البند لم يعد متاحا',
  otherFunctions: 'وظائف أخرى',
  returnToFirstPanorama: 'العودة إلى البانوراما الأولى',
  cookieBannerContent: 'We use cookies to enhance your browsing experience, serve personalized ads or content. By forwarding of viewing the website, you consent to our use of cookies. Please check',
  cookieBannerContentLinkAfter: 'for detail.',
  cookieBannerPolicyLinkText: 'Privacy Statement',
  cookieBannerButtonText: 'Accept'
}

export default ar
